import { scrollTo } from './services/utils'

export default class ButtonFollow {
  constructor() {
    const buttons = document.querySelectorAll('[data-scroll-to]')

    buttons.forEach((e) => {
      e.addEventListener('click', () => {
        scrollTo(document.querySelector(e.dataset.scrollTo))
      })
    })
  }
}
